import endpoint from "../../config/endpoints";

export const MyClaimJson = {
  showSaveNextBtn: true,
  formPath: "/my-claim-form",
  apiBaseURL: endpoint.claimApplyHeader,
  changeExcel: endpoint.exportData,
  screenTitle: "My Claim",
  showAddButton: true,
  showPdfDownload: false,
  pdfFileName: "MyClaim",
  showExcelDownload: true,
  excelFileName: "MyClaim",
  // formPathView: "/my-claim-view",
  tableColumnsToFilter: [
    {
      columnDisplayName: "Claim Name",
      columnKeyName: "name",
      isChecked: true,
    },
    {
      columnDisplayName: "Date",
      columnKeyName: "date",
      isChecked: true,
    },
    {
      columnDisplayName: "Amount",
      columnKeyName: "claimAmt",
      isChecked: true,
    },
    {
      columnDisplayName: "Type",
      columnKeyName: "claimType",
      isChecked: true,
    },
    {
      columnDisplayName: "No.Of Days",
      columnKeyName: "noOfDays",
      isChecked: true,
    },
    {
      columnDisplayName: "Status",
      columnKeyName: "status",
      isChecked: true,
    },

  ],
  fieldMeta: [

    {
      label: "Claim Structure",
      controlType: "autocomplete",
      placeHolder: "Select Claim Structure",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "claimStructureDetail",
      dataKey: "claimStructureHeader",
      isRootLevelKey: false,
      getListId: "claimStructureHeader",
      isMandatory: true,
    },
    {
      label: "Claim Type",
      controlType: "autocomplete",
      placeHolder: "Select Claim Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "claimTypeDetail",
      dataKey: "claimType",
      isRootLevelKey: false,
      getListFrom: "claimStructureHeader",
      isMandatory: true,
    },
    {
      label: "Claim To",
      controlType: "textfield",
      placeHolder: "Enter Rate",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "claimTo",
      isMandatory: false,
      disableTrue: true,
    },
    {
      label: "Claim Title",
      controlType: "textfield",
      placeHolder: "Claim Title",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      autoFocus: true,
      dataKey: "claimTitle",
      isMandatory: true,
    },
    // {
    //   label: "Claim To",
    //   controlType: "autocomplete",
    //   placeHolder: "Select Claim Tp",
    //   md: 6,
    //   lg: 6,
    //   sm: 6,
    //   xs: 12,
    //   masterName: "claimToDetail",
    //   dataKey: "ClaimTo",
    //   isRootLevelKey: false,
    //   getListId: "ClaimTo",
    //   isMandatory: true,
    // },
    {
      label: "Amount",
      controlType: "textfield",
      placeHolder: "Amount",
      inputType: "number",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      autoFocus: true,
      spValid: "float",
      dataKey: "amount",
      isMandatory: true,
    },
    {
      label: "Description",
      controlType: "textfield",
      placeHolder: "Description",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      autoFocus: true,
      dataKey: "description",
      isMandatory: true,
    },
    {
      label: "Select Image",
      controlType: "selectImage",
      placeHolder: "Select Image",
      inputType: "number",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKeyToSave: "imageUrl",
      dataKey: "claimImageToShow",
      isMandatory: false,
    },
  ],

  searchList: [
    {
      label: "Month",
      controlType: "monthpicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "month",
      isMandatory: true,
    },
  ],
};
